import { Button, Heading, Icon, Stack, Tab, Table, TableContainer, TabList, TabPanel, TabPanels, Tabs, Tbody, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { FaCheck, FaPlusCircle, FaUsers } from "react-icons/fa";


import SwitchButton from "../../components/Buttons/SwitchButton";
import BusinessDetails from "./BusinessDetails";
import KeyDates from "./KeyDates";
import Users from "./Users";

export default function BusinessProfile() {
    
    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaUsers}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Business Profile</Heading>
                            <Text fontSize={'sm'}>Manage access and user roles of full team members.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            leftIcon={<FaCheck />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Edit Fields
                        </Button>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <Tabs variant='enclosed'>
                    <TabList>
                        <Tab _selected={{ color: 'white', bg: 'primary.400' }}>Business Details</Tab>
                        <Tab _selected={{ color: 'white', bg: 'primary.400' }}>Key Dates</Tab>
                        <Tab _selected={{ color: 'white', bg: 'primary.400' }}>Users</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel as={Stack} spacing={2} py={6}>
                            <BusinessDetails />
                        </TabPanel>
                        <TabPanel>
                            <KeyDates />
                        </TabPanel>
                        <TabPanel>
                            <Users />
                        </TabPanel>
                    </TabPanels>
                </Tabs>

                <Stack spacing={4} w={'3xl'}>
                    <Stack direction={'row'} justify={'space-between'} align={'center'}>
                        <Heading fontSize={'xl'}>
                            Auto Forwarding Inboxes
                        </Heading>


                        <Button
                            size={'md'}
                            leftIcon={<FaPlusCircle />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Add Inbox
                        </Button>
                    </Stack>

                    <TableContainer overflowY={'scroll'}>
                        <Table size='sm'>
                            <Thead h={'30px'} bg={'blue.600'} alignItems={'flex-start'}>
                                <Tr>
                                    <Th
                                        color={'white'}
                                        w={'xs'}
                                    >
                                        Short Name
                                    </Th>
                                    <Th
                                        color={'white'}
                                    >
                                        Email
                                    </Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                            </Tbody>
                        </Table>
                    </TableContainer>

                    <Heading fontSize={'xl'}>Data Extraction Settings</Heading>
                    <Text>
                        What to do with duplicate documents identified on basis of following:
                    </Text>

                    <Stack
                        direction="row"
                        spacing={2}
                        bg={'gray.100'}
                        py={8}
                        align={'center'}
                        justify={'start'}
                        px={2}
                    >
                        <Text>Duplicate Files</Text>
                        <SwitchButton
                            firstButtonText={'Delete'}
                            secondButtonText={'Flag'}
                            activeButtonColor={'green.400'}
                            activeHoverColor={'green.500'}
                            activeClickColor={'green.600'}
                            inactiveButtonColor={'gray.400'}
                            inactiveHoverColor={'gray.500'}
                            inactiveClickColor={'gray.600'}
                            color={'white'}
                        />
                    </Stack>

                    <Stack
                        direction="row"
                        spacing={2}
                        py={8}
                        align={'center'}
                        justify={'start'}
                        px={2}
                    >
                        <Text>Duplicate Data</Text>
                        <SwitchButton
                            firstButtonText={'Delete'}
                            secondButtonText={'Flag'}
                            activeButtonColor={'green.400'}
                            activeHoverColor={'green.500'}
                            activeClickColor={'green.600'}
                            inactiveButtonColor={'gray.400'}
                            inactiveHoverColor={'gray.500'}
                            inactiveClickColor={'gray.600'}
                            color={'white'}
                        />
                    </Stack>

                    <Stack
                        direction="row"
                        spacing={2}
                        bg={'gray.100'}
                        py={8}
                        align={'center'}
                        justify={'start'}
                        px={2}
                    >
                        <Text>Supplier Statement to Invoices</Text>
                        <SwitchButton
                            firstButtonText={'Delete'}
                            secondButtonText={'Flag'}
                            activeButtonColor={'green.400'}
                            activeHoverColor={'green.500'}
                            activeClickColor={'green.600'}
                            inactiveButtonColor={'gray.400'}
                            inactiveHoverColor={'gray.500'}
                            inactiveClickColor={'gray.600'}
                            color={'white'}
                        />
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}